import { ChefHat, Trees, Maximize, Sparkles, ShoppingBasket, CalendarRange } from "lucide-react";

const ITEMS = [
  {
    title: "Fully serviced stay",
    body: "A full-time caretaker is available at the property to assist guests and prepare fresh home-cooked meals.",
    icon: ChefHat,
    span: "md:col-span-4",
  },
  {
    title: "Orchard living",
    body: "Enjoy fruit-bearing trees, flowering plants and peaceful green surroundings within the property.",
    icon: Trees,
    span: "md:col-span-4",
  },
  {
    title: "Expansive private compound",
    body: "The house sits within a very large open compound with plenty of room to walk, sit, play, read or simply breathe.",
    icon: Maximize,
    span: "md:col-span-4",
  },
  {
    title: "Modern comforts",
    body: "A single-storey home with modern amenities, contemporary fittings and comfortable living spaces.",
    icon: Sparkles,
    span: "md:col-span-6",
  },
  {
    title: "Everyday convenience",
    body: "A grocery store is located immediately outside the gate, making longer and self-paced stays easy.",
    icon: ShoppingBasket,
    span: "md:col-span-3",
  },
  {
    title: "Extended stays welcome",
    body: "ChiMano House is well suited for guests staying for several days, weeks or longer.",
    icon: CalendarRange,
    span: "md:col-span-3",
  },
];

export default function Highlights() {
  return (
    <section className="py-24 md:py-32 bg-[#EFEAE4] relative">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl mb-14 md:mb-20 reveal">
          <div className="text-[11px] uppercase tracking-[0.35em] text-[#985F47] mb-5">What ChiMano offers</div>
          <h2 className="serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tightest text-[#2C392F] font-light">
            Six small details that make a <span className="italic text-[#985F47]">larger difference.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-6">
          {ITEMS.map((item, idx) => {
            const Icon = item.icon;
            return (
              <article
                key={item.title}
                data-testid={`highlight-card-${idx}`}
                className={`reveal ${item.span} bg-[#F7F5F0] border border-[#2C392F]/10 rounded-2xl p-8 md:p-10 hover:border-[#985F47]/40 hover:shadow-sm transition-all flex flex-col`}
              >
                <Icon className="text-[#985F47] mb-6" size={26} strokeWidth={1.4} />
                <h3 className="serif text-2xl md:text-[28px] text-[#2C392F] leading-tight mb-3">{item.title}</h3>
                <p className="text-[#4A4D4A] text-[15px] leading-relaxed">{item.body}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
